import React, { useState, useEffect } from "react";
import {
  Card,
  Box,
  TextField,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContentText,
} from "@mui/material";
import Logo from "../../imagens/LogoVersao2Azul.svg";
import AuthService from "../../AuthService";
import Fundo from "../../imagens/fundo-qrpedir-min.png";
import { useSnackbar } from "notistack";

const AlterarSenha = ({ match }) => {
  const [password, setPassword] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [errorMessages, setErrorMessages] = useState({
    confirmarSenhaError: "",
  });
  const [token, setToken] = useState("");
  const [nome, setNome] = useState("");

  useEffect(() => {
    const { token } = match.params;
    if (!token) return;

    const service = new AuthService();
    service
      .get(`/usuario/getToken?token=${token}`)
      .then((retorno) => {
        setToken(true);
        setNome(retorno.username);
      })
      .catch(() => {
        setToken(false);
      });
  }, [match.params]);

  const handleSalvarSenha = () => {
    if (!password || !confirmarSenha) {
      setErrorMessages({
        confirmarSenhaError: "As senhas não podem ficar em branco",
      });
      return;
    }

    if (password !== confirmarSenha) {
      setErrorMessages({ confirmarSenhaError: "As senhas são diferentes" });
      return;
    }

    const md5 = require("js-md5");
    const senha = md5(password);
    const { token } = match.params;

    const service = new AuthService();
    service
      .post(`/usuario/changePassword`, {
        password: senha,
        token,
        username: nome,
      })
      .then(() => {
        enqueueSnackbar("Senha alterada com sucesso", { variant: "success" });
        setConfirmacao(true);
      })
      .catch(() => {
        enqueueSnackbar(
          "Falha ao alterar a senha, tente novamente ou tente mais tarde",
          { variant: "error" }
        );
      });
  };

  document.title = "QR Pedir - Alterar senha";

  return (
    <div>
      {token === "" && !nome && <></>}

      <Box
        sx={{
          height: "100vh",
          background: `url(${Fundo}) repeat`,
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="flex-start"
          sx={{ height: "800px" }}
        >
          <img style={{ width: "30%" }} alt="logo" src={Logo} />

          <Card
            sx={{
              padding: "2vw",
              paddingBottom: "20px",
              width: "30vw",
              minWidth: "300px",
              maxWidth: "450px",
              maxHeight: "500px",
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography variant="h5">Alterar senha!</Typography>

              {token === true ? (
                <>
                  <TextField
                    label="Insira sua nova senha"
                    type="password"
                    variant="outlined"
                    sx={{ width: "400px", marginBottom: "10px" }}
                    onChange={(e) => setPassword(e.target.value)}
                    inputProps={{ maxLength: 15 }}
                  />

                  <TextField
                    label="Confirme sua nova senha"
                    type="password"
                    error={!!errorMessages.confirmarSenhaError}
                    helperText={errorMessages.confirmarSenhaError}
                    variant="outlined"
                    sx={{ width: "400px", marginBottom: "10px" }}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    inputProps={{ maxLength: 15 }}
                  />

                  <Button
                    color="primary"
                    variant="contained"
                    sx={{ margin: "40px 0px" }}
                    onClick={handleSalvarSenha}
                  >
                    Alterar
                  </Button>
                </>
              ) : (
                <Dialog open={true} maxWidth="xs" fullWidth align="center">
                  <DialogTitle>Token inválido</DialogTitle>
                  <DialogContentText>
                    O token informado está incorreto ou já foi usado. Para gerar
                    um novo token clique no botão abaixo.
                  </DialogContentText>
                  <Box display="flex" justifyContent="center">
                    <Button
                      color="primary"
                      variant="contained"
                      sx={{ margin: "10px", width: "50%" }}
                      onClick={() => {
                        window.open("/RecuperarSenha", "_parent");
                      }}
                    >
                      Recuperar senha
                    </Button>
                  </Box>
                </Dialog>
              )}
            </Box>
          </Card>

          <Dialog
            open={confirmacao}
            onClose={() => setConfirmacao(false)}
            maxWidth="xs"
            fullWidth
            align="center"
          >
            <DialogTitle>Senha alterada com sucesso</DialogTitle>
            <DialogContentText>
              Para entrar na sua conta, vá para a tela inicial.
            </DialogContentText>
            <Box display="flex" justifyContent="center">
              <Button
                color="primary"
                variant="contained"
                sx={{ margin: "10px", width: "50%" }}
                onClick={() => {
                  window.open("/login", "_parent");
                }}
              >
                Tela inicial
              </Button>
            </Box>
          </Dialog>
        </Box>
      </Box>
    </div>
  );
};

export default AlterarSenha;
